var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8679 4.86993C12.1608 4.57704 12.1608 4.10216 11.8679 3.80927C11.575 3.51638 11.1002 3.51638 10.8073 3.80927L7.9376 6.67894L5.06793 3.80927C4.77503 3.51638 4.30016 3.51638 4.00727 3.80927C3.71437 4.10216 3.71437 4.57704 4.00727 4.86993L6.87694 7.7396L4.00727 10.6093C3.71437 10.9022 3.71437 11.377 4.00727 11.6699C4.30016 11.9628 4.77503 11.9628 5.06793 11.6699L7.9376 8.80026L10.8073 11.6699C11.1002 11.9628 11.575 11.9628 11.8679 11.6699C12.1608 11.377 12.1608 10.9022 11.8679 10.6093L8.99826 7.7396L11.8679 4.86993Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.3906d26a8b363daa70c1041034f4ea98.svg";
export { ForwardRef as ReactComponent };